import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext, useOfficeComponentContext, } from '@office-start/component-context-service';
import { useMemo } from 'react';
export function useAIHubEnabled(rootPath) {
    var componentContext = useOfficeComponentContext().data;
    var path = rootPath || (componentContext === null || componentContext === void 0 ? void 0 : componentContext.rootPath);
    return useMemo(function () { return isAIHubEnabled(path); }, [path]);
}
export function useAIHubAppHosted() {
    var componentContext = useOfficeComponentContext().data;
    var pathCheck = useMemo(function () {
        var _a;
        return (((_a = componentContext === null || componentContext === void 0 ? void 0 : componentContext.browserPathAndQueryString) === null || _a === void 0 ? void 0 : _a.startsWith('/v3/apphosted')) || false);
    }, [componentContext === null || componentContext === void 0 ? void 0 : componentContext.browserPathAndQueryString]);
    return pathCheck;
}
export function fetchAIHubEnabled() {
    return __awaiter(this, void 0, void 0, function () {
        var context;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    context = _a.sent();
                    return [2 /*return*/, isAIHubEnabled(context === null || context === void 0 ? void 0 : context.rootPath)];
            }
        });
    });
}
function isAIHubEnabled(rootPath) {
    return rootPath === '/v3';
}
export function isCatchUpNativeDisabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubCatchUpModuleNativeIntegrationDisabled);
}
export function isPrepareNativeModuleEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubPrepareModuleNativeIntegrationEnabled);
}
export function isCollectEnabledForV2(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubCollectModuleEnabledForV2);
}
export function isCreateNativeEnabled(featureGates) {
    var _a;
    // NOTE: This is checking if MOS is enabled. We want to show the native module by default.
    return !((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubCreateModuleMOSIntegrationEnabled);
}
export function isAssistModuleEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubAssistModuleEnabled);
}
export function isAutomateModuleDisabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubAutomateModuleDisabled);
}
export function isSharedDocumentCardsEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubSharedComponentDocumentCardsEnabled);
}
//# sourceMappingURL=useAIHubEnabled.js.map